import React from "react";
import styles from "./HeaderFoam.module.scss";
import { ReactSVG } from "react-svg";
import { OptionsBackgroundLayoutType } from "@/types/OptionType";

interface HeaderFoamProps {
  backgroundImages: OptionsBackgroundLayoutType;
  foamColor: string;
  isHeroHeader?: boolean;
}

export const HeaderFoam = ({
  backgroundImages,
  foamColor,
  isHeroHeader = false,
}: HeaderFoamProps) => {
  if (!backgroundImages || !backgroundImages.background_mixed) {
    return null;
  }

  return (
    <div
      data-color={foamColor}
      className={styles["foam-wrapper"]}
      data-header={isHeroHeader ? "hero" : "pages"}
    >
      <div>
        <div data-rotate={false} className={styles["svg-wrapper"]}>
          <ReactSVG src={backgroundImages.background_mixed.url} aria-hidden />
        </div>
      </div>
      <div>
        <div data-rotate={true} className={styles["svg-wrapper"]}>
          <ReactSVG src={backgroundImages.background_mixed.url} aria-hidden />
        </div>
      </div>
    </div>
  );
};
